import * as React from 'react';
export const ambankSvg = React.forwardRef(function ambankSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#ED1C24',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M21.383 8.002a7.618 7.618 0 1 1-.676 15.206l-.333-.037-.005-4.738.243.077a2.991 2.991 0 1 0 .976-5.872l-.205-.007a2.984 2.984 0 0 0-2.458 1.287l-.118.185a8.378 8.378 0 0 0-2.263-4.34l-.01-.018a7.593 7.593 0 0 1 4.849-1.743ZM10.616 8a7.617 7.617 0 0 1 7.613 7.333l.006.285.003 7.585h-4.63v-7.616a2.99 2.99 0 0 0-2.787-2.983l-.205-.007-.204.007a2.99 2.99 0 0 0 0 5.965l.204.007.246-.01a2.982 2.982 0 0 0 1.867-.863l.157-.167-.004 5.356A7.617 7.617 0 0 1 3 15.618 7.617 7.617 0 0 1 10.616 8Z',
      fill: '#fff',
    }),
  );
});
ambankSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var ambank = {
  category: 'brand',
  colorable: false,
  name: 'ambank',
  svg: ambankSvg,
};
